import type { ComputedRef, InjectionKey, Ref, WritableComputedRef } from 'vue'
import type { Audience, WebappMission } from '@/types/types'

export interface CustomerStatusState {
  isEnabled: boolean
  audienceIds: number[]
}

export interface PointsExclusionState {
  isEnabled: boolean
  audienceIds: number[]
}

export type AudiencePreviewRule = 'status' | 'points'

export interface EditorLoyaltyData {
  missions: Ref<WebappMission[]>
  isLoadingMissions: Ref<boolean>
  missionsError: Ref<boolean>
  reloadMissions: () => Promise<void>
  customerStatus: Ref<CustomerStatusState>
  pointsExclusion: Ref<PointsExclusionState>
  audiencePreviewRule: Ref<AudiencePreviewRule | null>
  audiences: Ref<Audience[]>
  primaryColor: ComputedRef<string>
  pointsLabel: ComputedRef<string>
  hasFormCompletion: WritableComputedRef<boolean>
}

export const EDITOR_LOYALTY_DATA: InjectionKey<EditorLoyaltyData> = Symbol('editorLoyaltyData')

export const useEditorLoyaltyData = (): EditorLoyaltyData => {
  const data = inject(EDITOR_LOYALTY_DATA)
  if (!data) throw new Error('useEditorLoyaltyData must be used inside the brand app editor')

  return data
}
